import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./LanguageSelector.css";

const languageItems = {
    es: {
        name: "ES",
        description: "Español",
    },
    en: {
        name: "EN",
        description: "English",
    },
    "pt-BR": {
        name: "PT",
        description: "Português",
    },
};

const LanguageSelector = () => {
    const { i18n } = useTranslation("common");
    const [languageSelected, setLanguageSelected] = useState(i18n.language || "es");

    const handleLanguageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setLanguageSelected(event.target.value);
    };

    useEffect(() => {
        i18n.changeLanguage(languageSelected);
        localStorage.setItem("language", languageSelected);
    }, [languageSelected, i18n]);

    return (
        <div className="lang-selector-cont">
            <select
                value={languageSelected}
                onChange={handleLanguageChange}
                className="lang-selector"
            >
                {Object.entries(languageItems).map(([key, value]) => (
                    <option key={key} value={key}>
                        {value.name} - {value.description}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default LanguageSelector;